import { render, staticRenderFns } from "./dragModal.vue?vue&type=template&id=277e37ea&"
import script from "./dragModal.vue?vue&type=script&lang=js&"
export * from "./dragModal.vue?vue&type=script&lang=js&"
import style0 from "./dragModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports